import React, { useMemo } from 'react';
import { TDialogWrapperComponent } from '../../../../../../components/dialog/index.types';
import { transactions as types } from 'types';
import { EWithdrawStatusSet } from '../../../../../../types/entities/transactions';
import DialogForm from '../../../../../../components/dialog/dialog-form';
import { Body1 } from 'components/typography';
import FormikTextArea from '../../../../../../components/form/formik/textarea';
import { ELabelPos } from '../../../../../../components/form/formik/types';
import useSetTransStatus from '../../hooks/use-set-transaction-status';
import mapTransTypesToUrlNames from '../../../../../../data-mappers/map-transaction-types-to-url-names';
import getInfoCompByTransType from '../../components/info-by-trans-type/get-info-by-trans-type';

type TFormValues = {
    rejectReason: string;
};

const initValues: TFormValues = {
    rejectReason: '',
};

const DialogReject: React.FC<
    { curData: types.TTransactions } & TDialogWrapperComponent
> = ({ asyncStatesHandlers, setIsDialogOpen, isDialogOpen, curData }) => {
    const [setTrans] = useSetTransStatus(asyncStatesHandlers);

    const InfoComp = useMemo(() => getInfoCompByTransType(curData), [curData]);

    return (
        <DialogForm
            isDialogOpen={isDialogOpen}
            setIsDialogOpen={setIsDialogOpen}
            title={'Reject'}
            initValues={initValues}
            validate={(values) => {
                let errors: Partial<TFormValues> = {};

                if (values.rejectReason.length === 0) {
                    errors.rejectReason = 'Required';
                }
                if (values.rejectReason.length < 6) {
                    errors.rejectReason = 'Min. 6 characters';
                }
                return errors;
            }}
            onSubmit={async (values) => {
                await setTrans({
                    params: {
                        status: EWithdrawStatusSet.REJECTED,
                        transactionId: curData.id,
                        rejectReason: values.rejectReason,
                        type: mapTransTypesToUrlNames(curData.type),
                    },
                });
            }}
        >
            <Body1>
                You want to reject?
                <InfoComp curData={curData} />
            </Body1>
            <FormikTextArea
                wide
                labelPos={ELabelPos.top}
                label={'Reason of reject (required)'}
                name={'rejectReason'}
                rows={2}
                cols={40}
            />
        </DialogForm>
    );
};

export default DialogReject;
